import type { IconProps } from "types";

const ChannelCollective = ({ color = "#B3B3B3", width = "20px", height = "20px" }: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4577_24351)">
        <path
          d="M7.42385 2.07479C3.04544 3.4954 0.654197 8.19885 2.07478 12.5732C3.49536 16.9475 8.19868 19.343 12.5729 17.9224C16.9513 16.5017 19.3426 11.7983 17.922 7.42398C16.5014 3.04547 11.7981 0.654171 7.42385 2.07479Z"
          stroke={color}
          strokeWidth="1.68321"
          strokeMiterlimit="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.1673 8.74984L10.0007 5.4165L5.83398 8.74984L7.50065 13.7498H12.5007L14.1673 8.74984Z"
          stroke={color}
          strokeWidth="1.68321"
          strokeMiterlimit="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.166 8.75L17.916 7.5"
          stroke={color}
          strokeWidth="1.68321"
          strokeMiterlimit="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.9999 16.6663L12.4999 13.7496"
          stroke={color}
          strokeWidth="1.68321"
          strokeMiterlimit="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.49974 13.7496L4.99974 16.6663"
          stroke={color}
          strokeWidth="1.68321"
          strokeMiterlimit="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.83398 8.75L2.08398 7.5"
          stroke={color}
          strokeWidth="1.68321"
          strokeMiterlimit="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99951 5.41602V1.66602"
          stroke={color}
          strokeWidth="1.68321"
          strokeMiterlimit="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4577_24351">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default ChannelCollective;
